(function (app, ng) {
    app.component("agentBasicInfo",
        {
            controller: agentBasicInfoController,
            templateUrl: "/App/Dashboard/ConfigureAgentAccount/AgentAccount/template.html",
            bindings: {
                onSave: "&",
                user: "<",
                viewAsUserRoles: "<",
                lineOfBusinessCategories: "<"
            }
        });
    agentBasicInfoController.$inject = ["$q", "userApi", "states", "transactionGroupUserMemberApi", "transactionGroupApi", "$state", "$timeout"];
    function agentBasicInfoController($q, userApi, states, transactionGroupUserMemberApi, transactionGroupApi, $state, $timeout) {
        var $ctrl = this;
        var comparisonUser = {};

        ng.extend($ctrl,
            {

                UI: {
                    isSaving: false,
                    isClosing: false,
                    nameUpdate: false,
                    emailUpdate: false,
                    phoneUpdate: false,
                    addressUpdate: false
                },
                states: states,
                updateUserData: updateUserData,
                updateRole: updateRole,
                updateAllowedLobCatIds: updateAllowedLobCatIds,
                editPhoneText: editPhoneText
            });



        this.$onInit = function () {
            $ctrl.states = states;
            $ctrl.currentState = $state.current.name;
            $ctrl.onSave({
                $func: function () {
                    return updateUserData();
                }
            });
            if ($ctrl.user)
                comparisonUser = ng.copy($ctrl.user);
            transactionGroupApi.getTransactionGroups().catch(ng.noop).then(function (groups) {
                $ctrl.transactionGroups = groups;
                return;
            }).then(function () {
                //load user's transaction group if getting list of groups is forbidden (don't have permissions)
                if ($ctrl.transactionGroups === null) {
                    $ctrl.transactionGroups = [];
                    transactionGroupApi.getTransactionGroup($ctrl.user.TransactionGroupId).then(function (group) {
                        $ctrl.transactionGroups.push(group);
                    });
                }
            });

        };

        function updateRole(role) {
            if (($ctrl.viewAsUserRoles.includes('ComplianceAdministrator') || $ctrl.viewAsUserRoles.includes('EntityAdministrator')) && $ctrl.currentState.includes('Home.ManageUsers')) {
                var index = $ctrl.user.Roles.indexOf(role);
                if (index !== -1)
                    $ctrl.user.Roles.splice(index, 1);
                else
                    $ctrl.user.Roles.push(role);
            }
        }

        function updateAllowedLobCatIds(id) {
            if (($ctrl.viewAsUserRoles.includes('ComplianceAdministrator') || $ctrl.viewAsUserRoles.includes('EntityAdministrator')) && $ctrl.currentState.includes('Home.ManageUsers')) {
                var index = $ctrl.user.AllowedLineOfBusinessCategoryIds.indexOf(id);
                if (index !== -1)
                    $ctrl.user.AllowedLineOfBusinessCategoryIds.splice(index, 1);
                else
                    $ctrl.user.AllowedLineOfBusinessCategoryIds.push(id);
            }
        }

        function editPhoneText() {
            $ctrl.editPhone = true;
            $timeout(function () {
                document.getElementById("phoneText").select();
            });
        };

        function updateUserData() {
            $ctrl.editPhone = false;
            var promises = [];

            if (!ng.equals($ctrl.user, comparisonUser)) {
                promises.push(userApi.UpdateUserInformation($ctrl.user.User));
            }

            if (!ng.equals($ctrl.user.Roles, comparisonUser.Roles)) {
                promises.push(transactionGroupUserMemberApi.updateUserMemberRoles($ctrl.user));
            }

            if (!ng.equals($ctrl.user.AllowedLineOfBusinessCategoryIds, comparisonUser.AllowedLineOfBusinessCategoryIds)) {
                promises.push(transactionGroupUserMemberApi.updateUserMemberAllowedLineOfBusinessCategoryIds($ctrl.user));
            }

            if (!ng.equals($ctrl.user.IsActive, comparisonUser.IsActive)) {
                promises.push(transactionGroupUserMemberApi.updateIsActive($ctrl.user));
            }

            if (!ng.equals($ctrl.user.TransactionGroupId, comparisonUser.TransactionGroupId)) {
                promises.push(transactionGroupUserMemberApi.updateUserMemberTransactionGroup($ctrl.user));
            }


            //promises.push(userApi.UpdateUserInformation($ctrl.user.User));
            //promises.push(transactionGroupUserMemberApi.updateUserMemberRoles($ctrl.user));
            //promises.push(transactionGroupUserMemberApi.updateIsActive($ctrl.user));

            return $q.all(promises).then(function () {
                return comparisonUser = ng.copy($ctrl.user);
            });
        }

    }
})(window.app, window.angular); //jshint ignore:line